import React, { useRef, useState } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/lib/ReactCrop.scss";
import "./CropImage.scss";
import { base64StringtoFile, image64toCanvasRef } from "./ResuableUtils";
import { FormFooterModal } from "../Modals/Modals";
import ToolTips from "../../ReusableComponents/ToolTips/ToolTips";
import { CheckValue } from "../../../services/CommonFunction";

const ImageCrop = ({
  change,
  imgSrc,
  name,
  imgSrcExt,
  isLandscape,
  ...props
}) => {
  const imagePreviewCanvasRef = useRef(null);
  const [crop, setCrop] = useState(props.crop);
  const [cropStatus, setCropStatus] = useState(props.cropStatus);
  const [minHeight, setMinHeight] = useState(props.minHeight || 50);
  const handleImageLoaded = (image) => {};
  const handleImageError = (event) => {};
  const handleOnCropChange = (currentCrop, pixelCrop) => {
    setCrop(pixelCrop);
    setCropStatus(currentCrop.width === 0 || currentCrop.height === 0);
  };

  const handleOnCropComplete = (currentCrop, pixelCrop) => {
    const canvasRef = imagePreviewCanvasRef.current;
    image64toCanvasRef(canvasRef, imgSrc, pixelCrop);
    // setTimeout(() => {
    //     handleDoneClick();
    // }, 1000 * 0.3);
  };
  const handleDoneClick = (event) => {
    if (event) {
      event.preventDefault();
    }
    if (!cropStatus) {
      if (imgSrc) {
        const canvasRef = imagePreviewCanvasRef.current;
        const imageData64 = canvasRef.toDataURL("image/" + imgSrcExt);
        const myFilename = +new Date() + imgSrcExt;
        // file to be uploaded
        const myNewCroppedFile = base64StringtoFile(imageData64, myFilename);
        change({ file: myNewCroppedFile, crop: crop });
      }
    }
  };
  return (
    <React.Fragment>
      <div className="crop_div custom_crop announcement_crop">
        <div className="">
          <ReactCrop
            className="custom_ReactCrop"
            src={imgSrc}
            crop={crop}
            // locked={true}
            keepSelection={true}
            minHeight={minHeight}
            onImageLoaded={handleImageLoaded}
            onImageError={handleImageError}
            onComplete={handleOnCropComplete}
            onChange={handleOnCropChange}
          />
        </div>
        <div
          className={`custom_crop_leftside${
            CheckValue(isLandscape) && isLandscape ? " landscape" : ""
          }`}
        >
          {CheckValue(isLandscape) && isLandscape ? null : (
            <div className="text">
              <ToolTips
                showTooltip={true}
                overflow={true}
                position="top"
                message={name}
                styleClas="categoryText"
                height={true}
                messageClass="messageClass_uc"
              >
                {name}
              </ToolTips>
            </div>
          )}
          <canvas ref={imagePreviewCanvasRef} />
          {/* <div className="custom_crop_leftside_cut"></div> */}
        </div>
      </div>
      <FormFooterModal
        {...props}
        submit={handleDoneClick}
        submitText={`Save`}
        invalid={false}
      />
    </React.Fragment>
  );
};

export default ImageCrop;
